$(document).ready(function () {
  var $header = $('#js-header');
  var $body = $('body');
  var stickyPoint = 50;

  // Sticky header
  function updateSticky() {
    if ($(window).scrollTop() >= stickyPoint) {
      $header.addClass('sticky');
    } else {
      $header.removeClass('sticky');
    }
  }
  updateSticky();
  $(window).on('scroll', updateSticky);

  // Mobile menu toggle
  $('.js-toggle-mob-menu').on('click', function () {
    $header.toggleClass('menu-active');
    $body.toggleClass('gh-head-open', $header.hasClass('menu-active'));
    $('#js-mobile-menu').attr('aria-hidden', !$header.hasClass('menu-active'));
  });

  $('.js-close-mob-menu').on('click', function () {
    $header.removeClass('menu-active');
    $body.removeClass('gh-head-open');
    $('#js-mobile-menu').attr('aria-hidden', 'true');
    $('.header-navigation-item.has-megamenu').removeClass('is-open');
  });

  // Close mobile menu on nav link click
  $('#js-mobile-menu a').on('click', function () {
    $header.removeClass('menu-active');
    $body.removeClass('gh-head-open');
    $('#js-mobile-menu').attr('aria-hidden', 'true');
  });

  // FitVids
  $('.gh-content').fitVids();

  // Context menu on logo right-click
  var $contextMenu = $('#js-brand-context-menu');

  $('.js-logo-context').on('contextmenu', function (e) {
    e.preventDefault();
    e.stopPropagation();
    var rect = this.getBoundingClientRect();
    var x = rect.left;
    var y = rect.bottom + 10;

    $contextMenu.css({ left: x, top: y }).addClass('is-open').attr('aria-hidden', 'false');
  });

  function closeContextMenu() {
    $contextMenu.removeClass('is-open').attr('aria-hidden', 'true');
  }

  $(document).on('click', closeContextMenu);
  $(document).on('keydown', function (e) {
    if (e.key === 'Escape') closeContextMenu();
  });
});
